import { useState } from 'react';

export default function HalloweenBrandLogo() {
  const [run, setRun] = useState(0);
  const [playing, setPlaying] = useState(true);

  const replay = () => {
    if (playing) return;
    setPlaying(true);
    setRun((current) => current + 1);
  };

  return (
    <span
      key={run}
      className="relative inline-block"
      onMouseEnter={replay}
      onAnimationEnd={() => setPlaying(false)}
    >
      <img
        src="/assets/logo-white.svg"
        alt="welya-logo"
        className="animate-welya-haunt h-[29px] w-auto"
      />
      <span
        aria-hidden
        className="animate-webinarjam-boo pointer-events-none absolute left-0 top-0 flex flex-col items-start gap-2 whitespace-nowrap opacity-0"
      >
        <span className="flex h-[29px] items-center rounded-md bg-white px-2">
          <img src="/assets/webinarjam-logo.svg" alt="" className="h-[19px] w-auto" />
        </span>
        <span className="animate-boo-text text-xl font-bold text-orange-400">BOUH ! 👻</span>
      </span>
    </span>
  );
}
